import { Jumbo } from '@zomato/jumbo-client';
import { isMobile, getCookieForEntity } from '../utils/helpers';
import { COOKIE_KEYS } from '../utils/constants/others';

const jumboInstance = new Jumbo({});

const APP_SOURCE_PARTNER_WEB = "PARTNER_WEB";
const APP_SOURCE_PETPOOJA_WEB = "PETPOOJA_WEB";
const APP_SOURCE_HYPERPURE = "HYPERPURE";

// Get app source based on context (similar to Go logic)
const getAppSource = () => {
    // Check if it's PetPooja client
    const clientType = getCookieForEntity("", "clientType");
    if (clientType === "petpooja") {
        return APP_SOURCE_PETPOOJA_WEB;
    }
    
    // Check URL patterns or other indicators for partner apps
    const hostname = window.location.hostname;
    if (hostname.includes('partner')) {
        return APP_SOURCE_PARTNER_WEB;
    }
    
    // Default to Hyperpure
    return APP_SOURCE_HYPERPURE;
};

// Get app mode from cookies or context
const getAppMode = () => {
    return getCookieForEntity(COOKIE_KEYS.APP_MODE, COOKIE_KEYS.APP_MODE) || "STANDARD";    
};

// Get jumbo source for device detection
const getJumboSource = () => {
    return isMobile() ? 'mweb' : 'web';
};

export const sendEventToJumbo = async (tableKey, payload, userData) => {
    // Skip in local development
    if (process.env.REACT_APP_API_ENDPOINT === "development" || process.env.REACT_APP_API_ENDPOINT === "devServer") {
        console.debug("Tracking event", payload);
        return;
    }

    // Clone payload to avoid mutations
    const payloadMap = { ...payload };

    const deviceId = jumboInstance.getDeviceId() || '';
    const userAgent = navigator.userAgent;
    const source = getJumboSource();
    const appSource = getAppSource();
    const appMode = getAppMode();
    const referrer = document.referrer || '';
    const url = window.location.href;

    // Add app-specific metadata to payload
    payloadMap.app_source = appSource;
    payloadMap.app_mode = appMode;
    payloadMap.referrer = referrer;
    payloadMap.request_url = url;

    //User specific details
    const userId = userData?.user?.id;
    payloadMap.outlet_id = userData?.outlet?.id;
    payloadMap.user_id = userData?.user?.id;
    payloadMap.account_id = userId;


    // Set jumbo params
    jumboInstance.setParams({
        user_id: String(userId),
        device_id: deviceId,
        custom_headers: {
            source: source,
        },
    });

    // Create the event payload
    const eventPayload = {
        ...payloadMap,
        user_agent: userAgent,
    };

    jumboInstance.sendToJumbo(tableKey, eventPayload);

};